import { useEffect, useRef, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import './style.scss'

const DropDownList = ({ list, translate = false, selectedValue, changeValue }) => {
  const [open, setOpen] = useState(false)
  const dropDownRef = useRef(null)

  const { t } = useTranslation('basic')
  const displayName = (text) => translate ? t(text) : text

  useEffect(() => {
    if (open) {
      const click = (e) => {
        if (dropDownRef.current && e.target instanceof Node && !dropDownRef.current.contains(e.target)) {
          setOpen(false)
        }
      }
      window.addEventListener('click', click)
      return () => {
        window.removeEventListener('click', click)
      }
    }
  }, [open])

  return (
    <div
      ref={dropDownRef}
      className='dropDown'
      onClick={() => {
        if (!open) setOpen(true)
      }}>
      <div className='dropDown__selected'>
        {displayName(list.find(l => l.value === selectedValue)?.name)}
      </div>
      {open && <div className='dropDown__list'>
        {list.map(({ name, value }) => <div
          key={value}
          className={`dropDown__item ${selectedValue === value ? '--selected' : ''}`}
          onClick={() => {
            changeValue(value)
            setOpen(false)
          }}>
          <p>{displayName(name)}</p>
        </div>)}
      </div>}
    </div>
  )
}

export default DropDownList